import React, { useState, useEffect, createRef } from 'react';
import styled from 'styled-components';
import { Icon } from '@zebra-fed/zds-react-desktop';
import TextField from '@material-ui/core/TextField'; 
import '@zebra-fed/icons/General/index.css';
import {useTranslation} from "react-i18next";
import SearchIcon from '@material-ui/icons/Search';
import { Button, RadioButtonGroup, Item } from "@zebra-fed/zds-react-desktop";

const ToolbarWrapper = styled.div`
    display: flex;
    // justify-content: space-between;
    justify-content: end;
    align-items: center;
    // padding: 0 18px;
    // border: 2px solid red;
    // position: absolute;
    z-index: 999;
    margin-right: auto;
    left: 0;
    right: 0;
    top: -60px;
    display: flex;
    flex-direction: column;
    // background: lightblue;
    align-items: end;
    // border: 1px solid;
    width: fit-content;
    right: 0;
    left: auto;
    padding: 5px;
    // background: #007ABA;
    border-radius: 4px;
    margin-right: 0;
    margin-left: auto;
    // border: 1px solid #bdbdbd;

`
const SearchIconCustom = styled(SearchIcon)`
    position: relative;
    &:hover {
        cursor: pointer;
    }
`;

const TitleText = styled.h1`
    font-size: 20px;
    display: flex;
`

const SearchBoxNComp = styled.div`
    background: white;
    // margin-right: 15px;
    padding: 10px;
    border: 1px solid #bdbdbd;
    position: absolute;
    top: 36px;
    z-index: 999;
`;

export default function Toolbar(props) {
    const { multiSearchOpts=[] } = props;
    const [searchVal, setSearchVal] = useState('');
    console.log('searchVal :', searchVal);
    const [isError, setIsError] = useState(false)
    const { t } = useTranslation();
    const [openSearchBox,setOpenSearchBox] = useState(false)
    const [searchOptVal, setSearchOptVal] = useState('')
    const radioRef = createRef();
    const [searchInputError, setSearchInputError] = useState("")
    const [searchOptError, setSearchOptError] = useState("")
    console.log('searchOptVal :', searchOptVal);

    useEffect(() => {
        setSearchVal(props.searchText)
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    // useEffect(() => {
    //     let optLength = [];
    //     optLength = radioRef.current?.getValues();
    //     console.log('optLength :', optLength);

    //     // if ( optLength.length > 0 ) {
    //     //     setSearchOptError("")
    //     // }
    // })

    function searchTheVal () {
        console.log('clicked clicked')
        console.log( radioRef.current.getValues());
        let optLength = radioRef.current.getValues().length;
        console.log('optLength :', optLength);

        if (!searchVal) {
            setSearchInputError('Enter a value to search')
        }
        if (multiSearchOpts.length > 0 && optLength === 0) {
            setSearchOptError('Choose a type')
        }

        else {
            props.onSearch(searchVal, searchOptVal)
        }

    }

    function onChangeOptItem(e) {
        setSearchOptError("");
        setSearchOptVal(e.target.value);
    }

    return (
        <ToolbarWrapper>
            {/* <Button
             type="primary"
             dense={true}
             style={{ margin: '10px' }}
            >Reset</Button> */}
            {/* <SearchIconCustom 
            // style={{color: 'white'}}
             onClick={()=>setOpenSearchBox(!openSearchBox)}/> */}
             <TextField 
        className='manageusers-search-box'
           error={isError}
           helperText={isError ? t('searchHelperText') : ""} //"Please enter a valid email id to search."
           style={{ }}
           placeholder={t('searchPlaceholderText')}
           value={searchVal}
           onFocus={()=>setOpenSearchBox(true)}
        //    onBlur={()=>setOpenSearchBox(false)}
           onChange={(e) => {
            
               setSearchVal(e.target.value.trim());
               setSearchInputError("")
               if (e.target.value === "") {
                   props.onClear(searchVal);
               }
           }}
           onKeyDownCapture={multiSearchOpts.length === 0 ? (e) => {
               if (e.keyCode === 13) {
                   if(e.target.value.trim() === "")
                       setIsError(true)

                   props.onSearch(searchVal)
               }
           } : false}
           InputProps= {{
               startAdornment: 
                   <Icon 
                       category={'general'}
                       name={'search'}
                       size={15}
                       style={{cursor: 'pointer', padding: '0 8px 4px 0'}}
                       color={'#bdbdbd'}
                    //    onClick={() => {
                    //        props.onSearch(searchVal)
                    //    }}
                   />,
               endAdornment:
                   <Icon 
                       category={'navigation'}
                       name={'close'}
                       size={15}
                       style={{cursor: 'pointer', paddingRight: '4px', 
                    //    display: searchVal === '' ? 'none' : 'block'
                    }}
                    
                       color={'#bdbdbd'}
                       onClick={() => {
                        if ( searchVal ) {
                            setSearchVal('')
                            props.onClear(searchVal)
                        }
                       }}
                   />,
           }}
       />
         {
           openSearchBox && multiSearchOpts.length > 0 &&
           <SearchBoxNComp>
           {/* <TextField
           error={isError}
           helperText={isError ? t('searchHelperText') : ""} //"Please enter a valid email id to search."
           style={{ }}
           placeholder={t('searchPlaceholderText')}
           value={searchVal}
           onChange={(e) => {
               setSearchVal(e.target.value.trim());
               setSearchInputError("")
               if (e.target.value === "") {
                   props.onClear(searchVal);
               }
           }}
        //    onKeyDownCapture={(e) => {
        //        if (e.keyCode === 13) {
        //            if(e.target.value.trim() === "")
        //                setIsError(true)

        //            props.onSearch(searchVal)
        //        }
        //    }}
           InputProps= {{
               startAdornment: 
                   <Icon 
                       category={'general'}
                       name={'search'}
                       size={15}
                       style={{cursor: 'pointer', padding: '0 8px 4px 0'}}
                       color={'#bdbdbd'}
                    //    onClick={() => {
                    //        props.onSearch(searchVal)
                    //    }}
                   />,
               endAdornment:
                   <Icon 
                       category={'navigation'}
                       name={'close'}
                       size={15}
                       style={{cursor: 'pointer', paddingRight: '4px', display: searchVal === '' ? 'none' : 'block'}}
                       color={'#bdbdbd'}
                       onClick={() => {
                           setSearchVal('')
                           props.onClear(searchVal)
                       }}
                   />,
           }}
       /> */}
       {searchInputError && <p style={{color: 'red', margin: '0'}}>{searchInputError }</p>}
       <p>{t('matchResultIn')}:</p>
       <RadioButtonGroup
        align="left"
        ref={radioRef}
        // onChange={(e)=>setSearchOptVal(e.target.value), ()=>setSearchOptError("")}
        // onChange={()=>setSearchOptError("")}
        onChange={onChangeOptItem}
        >
            {multiSearchOpts.map((opts,idx) => <Item key={idx}
            defaultChecked={opts.value === searchOptVal}
        // onChange={()=>setSearchOptError("")}
        value={opts.value}>{opts.name}</Item> )}
          </RadioButtonGroup>
       {searchOptError && <p style={{color: 'red', margin: '0'}}>{searchOptError }</p>}

          <div>
              <Button
                type="primary"
                dense={true}
                style={{ margin: '10px' }}
                onClick={()=>setOpenSearchBox(!openSearchBox)}
              >{t('cancel')}</Button>
              <Button
                type="primary"
                dense={true}
                style={{ margin: '10px' }}
                onClick={()=>searchTheVal()}
              >{t('search')}</Button>
          </div>
       </SearchBoxNComp>
         } 
            {/* <TitleText>{t('allUser')}</TitleText> */}
            {/* <TextField
                error={isError}
                helperText={isError ? t('searchHelperText') : ""} //"Please enter a valid email id to search."
                style={{ width: '30%'}}
                placeholder={t('searchPlaceholderText')}
                value={searchVal}
                onChange={(e) => {
                    setSearchVal(e.target.value.trim());
                    if (e.target.value === "") {
                        props.onClear(searchVal);
                    }
                }}
                onKeyDownCapture={(e) => {
                    if (e.keyCode === 13) {
                        if(e.target.value.trim() === "")
                            setIsError(true)

                        props.onSearch(searchVal)
                    }
                }}
                InputProps= {{
                    startAdornment: 
                        <Icon 
                            category={'general'}
                            name={'search'}
                            size={15}
                            style={{cursor: 'pointer', padding: '0 8px 4px 0'}}
                            color={'#bdbdbd'}
                            onClick={() => {
                                props.onSearch(searchVal)
                            }}
                        />,
                    endAdornment:
                        <Icon 
                            category={'navigation'}
                            name={'close'}
                            size={15}
                            style={{cursor: 'pointer', paddingRight: '4px', display: searchVal === '' ? 'none' : 'block'}}
                            color={'#bdbdbd'}
                            onClick={() => {
                                setSearchVal('')
                                props.onClear(searchVal)
                            }}
                        />,
                }}
            /> */}
        </ToolbarWrapper>
    )
}